// src/pages/Profile/components/EditProfileModal.jsx

import React from "react";
import { FaPen, FaSave, FaTimes } from "react-icons/fa";

import ActionButton from "../ui/ActionButton";
import ProfileField from "../ui/ProfileField";

export default function EditProfileModal({
  user,
  onChange,
  onSubmit,
  onClose,
}) {
  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/75 px-4 py-6 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative w-full max-w-lg overflow-hidden rounded-[2rem] border border-white/10 bg-white p-6 shadow-2xl dark:bg-slate-950 sm:p-8"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:text-primary dark:border-white/10 dark:bg-white/5 dark:text-slate-200"
          aria-label="Fermer"
        >
          <FaTimes />
        </button>

        <div className="pr-10">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-orange-100 text-primary dark:bg-orange-500/10">
            <FaPen />
          </div>

          <h3 className="mt-5 font-barlow text-3xl font-bold text-slate-950 dark:text-white">
            Modifier le profil
          </h3>

          <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
            Mettez à jour votre nom et prénom.
          </p>
        </div>

        <form onSubmit={onSubmit} className="mt-7 space-y-5">
          <ProfileField
            label="Nom"
            name="nom"
            value={user.nom}
            onChange={onChange}
            autoComplete="family-name"
          />

          <ProfileField
            label="Prénom"
            name="prenom"
            value={user.prenom}
            onChange={onChange}
            autoComplete="given-name"
          />

          <div className="flex flex-col gap-3 pt-3 sm:flex-row sm:justify-end">
            <ActionButton icon={FaTimes} onClick={onClose} variant="secondary">
              Annuler
            </ActionButton>

            <ActionButton icon={FaSave} type="submit">
              Sauvegarder
            </ActionButton>
          </div>
        </form>
      </div>
    </div>
  );
}